// extracted by mini-css-extract-plugin
module.exports = {"InfoTable":"InfoTable_InfoTable__jZI3V","InfoTableRow":"InfoTable_InfoTableRow__1A51A","itemName":"InfoTable_itemName__lfZCc","InfoTableHeader":"InfoTable_InfoTableHeader__3UXM_"};